<div [ngClass]="{ 'in-edit-mode': editMode, empty: empty }" class="activate-button">
  <a
    [ngClass]="{ active: editMode, 'icon-edit-circle': !empty, 'icon-plus-circle': empty }"
    (click)="activate()"
    #popoverActivation
    class="icon-text-btn color-primary"
    href="javascript:;"
    title="{{ label || 'Edit' }}"
  >
    {{ label }}
  </a>
</div>
